import { GetWithToken } from "../../lib/request";


export const notifyCourier = async (orderMerchantId) => {
    return await GetWithToken(`/v2/flash/notify/${orderMerchantId}`);
};